import * as THREE from 'three'
import {create} from 'zustand'
import {gsap} from 'gsap'
import {DEFAULT_CAMERA_POS, DEFAULT_TARGET_POS, TOTAL_SONGS} from '../utils/constants.jsx'

export const useAppStore = create((set, get) => ({
    // --- States ---
    controlsInstance: null, // OrbitControls instance
    isAnimating: false,
    launchAnimationDone: false,
    activeTimeline: null,   // GSAP timeline instance
    sceneReady: false,
    controlsReady: false,

    // --- Panel States ---
    selectedObjectId: null,

    // --- Tablet States ---
    isTabletOpen: false,
    isTabletMinimized: false,
    selectedSong: 0,
    isSecretSongUnlocked: false,
    isSecretObjectVisible: false,

    // --- Actions ---
    setControlsInstance: (controls) => {
        set({controlsInstance: controls, controlsReady: !!controls})
    },

    setSceneReady: () => set({sceneReady: true}),

    killActiveAnimation: () => {
        const {activeTimeline} = get()
        if (activeTimeline) {
            console.log('Store: Killing active animation timeline.')
            activeTimeline.kill()
        }
        set({isAnimating: false, activeTimeline: null})
    },

    // --- Animation Actions ---
    focusOnObject: (targetPosition, cameraOffset) => {
        const {controlsInstance, killActiveAnimation} = get()
        if (!controlsInstance) return

        killActiveAnimation()

        const controls = controlsInstance
        const camera = controls.object
        const targetCamPos = new THREE.Vector3().addVectors(targetPosition, cameraOffset)

        console.log('Store: Animating camera to object:', targetPosition)
        set({isAnimating: true})

        const timeline = gsap.timeline({
            defaults: {duration: 0.75, ease: 'power4.out'},
            onComplete: () => {
                controls.update()
                set({isAnimating: false, activeTimeline: null})
                console.log('Store: Focus animation complete.')
            }
        })

        set({activeTimeline: timeline})

        timeline.to(controls.target, {...targetPosition}, 0)
        timeline.to(camera.position, {...targetCamPos,}, 0)
    },

    resetCamera: () => {
        const {controlsInstance, killActiveAnimation} = get()
        if (!controlsInstance) return

        killActiveAnimation()

        const controls = controlsInstance
        const camera = controls.object

        console.log('Store: Starting reset animation.')
        set({isAnimating: true})

        const timeline = gsap.timeline({
            defaults: {duration: 0.75, ease: 'power4.out'},
            onComplete: () => {
                controls.update()
                set({isAnimating: false, activeTimeline: null})
                console.log('Store: Reset animation complete.')
            }
        })

        set({activeTimeline: timeline})

        timeline.to(controls.target, {...DEFAULT_TARGET_POS}, 0)
        timeline.to(camera.position, {...DEFAULT_CAMERA_POS}, 0)
    },

    // --- Panel Actions ---
    selectObject: (objectInfoId) => {
        set({selectedObjectId: objectInfoId})
    },

    closePanel: () => set({selectedObjectId: null}),

    // --- Launch Animation ---
    launchAnimation: () => {
        const {controlsInstance, launchAnimationDone} = get()
        if (!controlsInstance || launchAnimationDone) return


        const controls = controlsInstance
        const camera = controls.object

        console.log('Store: Starting launch animation.')
        set({isAnimating: true})

        const timeline = gsap.timeline({
            defaults: {duration: 2, ease: 'power4.out'},
            onComplete: () => {
                controls.update()
                set({isAnimating: false, activeTimeline: null})
                console.log('Store: Launch animation complete.')
            }
        })

        set({activeTimeline: timeline})

        timeline.to(controls.target, {...DEFAULT_TARGET_POS}, 0)
        timeline.to(camera.position, {...DEFAULT_CAMERA_POS}, 0)

        set({launchAnimationDone: true})
    },

    // --- Tablet Actions ---
    openTablet: () => {
        set({isTabletOpen: true})
        console.log('Store: Tablet opened.')
    },
    closeTablet: () => {
        set({isTabletOpen: false})
        console.log('Store: Tablet closed.')
    },

    toggleMinimizeTablet: () => {
        set({isTabletMinimized: !get().isTabletMinimized})
    },

    nextSong: () => {
        const totalSongs = get().isSecretSongUnlocked ? TOTAL_SONGS + 1 : TOTAL_SONGS
        set((state) => ({
            selectedSong: (state.selectedSong + 1) % totalSongs

        }));
        console.log('Store: Next song:', get().selectedSong)
    },
    previousSong: () => {
        const totalSongs = get().isSecretSongUnlocked ? TOTAL_SONGS + 1 : TOTAL_SONGS
        set((state) => ({
            selectedSong: (state.selectedSong - 1 + totalSongs) % totalSongs
        }));
        console.log('Store: Previous song:', get().selectedSong)
    },

    unlockSecretSong: () => set({isSecretSongUnlocked: true}),
    showSecretObject: () => set({isSecretObjectVisible: true}),

}))